import { Container, Row, Col } from "react-bootstrap";
import "../components/styles/Aboutsec.css";
import logo from '../assets/productsec/aboutuser2.png';

function AboutSection() {
  return (
    <section id="about" className="about-section py-5">
      <Container>
        <div className="section-header mb-4">
          <h2>About Us</h2>
        </div>
        <Row className="align-items-center">
          <Col lg={6}>
            <h3 className="mb-4">Best Housekeeping Company in Chennai</h3>
            <h4 className="mb-3">
              Transforming Spaces with Professional Housekeeping Services – Clean, Safe, and Reliable!
            </h4>
            <div className="divider mb-4"></div>
            <p>
              At <strong>Sunshiny</strong>, we specialize in providing top-notch housekeeping services tailored to meet the unique needs of residential, commercial, and industrial spaces. With years of experience, we ensure your environment is clean, hygienic, and well-maintained.
            </p>
            <p>
              Our team of trained professionals is dedicated to delivering exceptional cleaning solutions, including <strong>residential cleaning</strong>, <strong>commercial cleaning</strong>, <strong>industrial cleaning</strong>, and <strong>specialized cleaning</strong> services. We also offer <strong>maintenance</strong> and <strong>sanitization services</strong> to keep your spaces safe and healthy.
            </p>
            <p>
              Whether it's a small home or a large industrial facility, we are committed to providing reliable and efficient housekeeping solutions that exceed your expectations.
            </p>
          </Col>
          <Col lg={6}>
            <div className="about-image">
              <img src={logo} alt="Housekeeping Services" className="img-fluid rounded shadow" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default AboutSection;